import React from 'react'
import "./Conclusion.css"

export default function Conclusion() {
  return (
    <>
      <div className="Conclusion"></div>
      <div className="ConclusionContent">
      With Diana, you're in control of your health, your every day, and your story.
      </div>
    </>
  )
}
